import { SnowflakeIcon, StoreIcon, UsersIcon, WrenchIcon } from 'lucide-react';
import { trustPoints } from '../data/site';
const icons = [UsersIcon, StoreIcon, WrenchIcon, SnowflakeIcon];
export function TrustStrip() {
  return <section aria-label="Why customers choose Pegasus Spas" className="w-full bg-water" data-id="element-255" data-mp="2jcat6cgpyf74">
      <div className="mx-auto max-w-container px-5 py-5 sm:px-8" data-id="element-256" data-mp="2fc0rvd3vgcyl">
        <ul className="grid grid-cols-1 gap-x-8 gap-y-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-257" data-mp="2f9o9iyu7c0l0">
          {trustPoints.map((point, index) => {
          const Icon = icons[index];
          return <li key={point} className="flex items-start gap-2.5" data-id="element-258" data-mp="25fny6f8btz3u" data-mpi={index}>
                <Icon className="mt-0.5 h-5 w-5 shrink-0 text-pine" aria-hidden="true" data-id="element-259" data-mp="20eqg02nbh52c" />
                <span className="text-[15.5px] font-medium leading-6 text-ink" data-id="element-260" data-mp="1wdy5z76mew50">{point}</span>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}